var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-container d-flex flex-column justify-content-center p-5"},[_c('h3',{staticClass:"title mb-4"},[_c('b',{domProps:{"textContent":_vm._s(_vm.title)}})]),_c('p',{staticClass:"message mb-5 text-muted",domProps:{"textContent":_vm._s(_vm.message)}}),_c('div',{staticClass:"w-50"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }